import { getAPIErrorMessage } from 'api';
import { openErrorDialogSimple } from 'console/dialogs/error/redux/actions';
import { getDeviceIdBySim, sim_for_device_selector } from 'console/sim/utils/select-sim';
export const removeForeignSim = (msisdn) => ({
    type: 'REMOVE_FOREIGN_SIM',
    msisdn,
});
export const removeBilledSim = (msisdn) => ({
    type: 'REMOVE_BILLED_SIM',
    msisdn,
});
export const removeSim = (sim_type, msisdn, iccid, sim_in_device) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'REMOVE_SIM_REQUEST' });
    try {
        const response = await api.sim_remove(sim_type, msisdn, iccid);
        const devices = sim_for_device_selector(getState());
        if (sim_in_device != null) {
            const device_id = getDeviceIdBySim(devices, sim_in_device);
            if (device_id != -1) {
                dispatch(changeSimInDevice(device_id, null));
            }
        }
        dispatch({ type: 'REMOVE_SIM_REQUEST__OK' });
        if (response.remove) {
            if (sim_type === 'foreign') {
                dispatch(removeForeignSim(msisdn));
            }
            else {
                dispatch(removeBilledSim(msisdn));
            }
        }
    }
    catch (e) {
        dispatch({
            type: 'REMOVE_SIM_REQUEST__FAIL',
            error: getAPIErrorMessage(e, 'Не удалось удалить сим-карту'),
        });
    }
};
export const request_sim_prolong_info = (sim_id, months) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'PROLONG_SIM_INFO__REQUEST', sim_id });
    try {
        const response = await api.get_prolong_info(sim_id, months, 0 - ~~(new Date().getTimezoneOffset() / 60));
        dispatch({
            type: 'PROLONG_SIM_INFO__OK',
            sim_id,
            months,
            amount_x100: response.amount_x100,
            until: response.until,
        });
    }
    catch ({ json }) {
        dispatch({
            type: 'PROLONG_SIM_INFO__FAIL',
            error: json.error,
            error_ui: json.error_ui ||
                json.error ||
                'Не удалось запросить информацию для продления',
        });
    }
};
export const setSimAutoProlong = (billed_sim, auto_prolong) => async (dispatch, getState, { api }) => {
    dispatch(update_billed_sim({ ...billed_sim, auto_prolong }));
    await api.set_sim_auto_prolong(billed_sim.sim_card.id, auto_prolong);
};
export const changeSimInDevice = (device_id, sim_in_device) => async (dispatch, getState, { api }) => {
    try {
        await api.update_device(device_id, { sim_in_device });
        dispatch({ type: 'CHANGE_SIM_IN_DEVICE', device_id, sim_in_device });
    }
    catch (e) {
        openErrorDialogSimple(e, 'Не удалось изменить сим-карту в устройству');
    }
};
export const update_foreign_sim = (foreign_sim) => ({
    type: 'UPDATE_FOREIGN_SIM',
    foreign_sim,
});
export const update_billed_sim = (billed_sim) => ({
    type: 'UPDATE_BILLED_SIM',
    billed_sim,
});
